/** Узкий список подтверждённых ручных правок. Импорт, массовые действия и удаления не дают наград. */
export function preparePetWork(path: string, init: RequestInit): ((response: unknown) => string | null) | null {
  if (init.method !== 'PATCH' || typeof init.body !== 'string') return null;
  const candidate = /^\/candidates\/([^/?]+)\/(cell|work-object)$/.exec(path);
  const sheet = /^\/sheets\/([^/?]+)\/cells$/.exec(path);
  if (!candidate && !sheet) return null;
  let body: Record<string, unknown>;
  try { body = JSON.parse(init.body); } catch { return null; }
  if (!body || typeof body !== 'object') return null;
  if (candidate) {
    if (typeof body.version !== 'number' || ['sectionId', 'sortOrder', 'rowColor'].includes(String(body.field))) return null;
    const version = body.version, key = `candidate:${candidate[1]}`;
    return response => {
      const saved = response as { version?: number } | null;
      return typeof saved?.version === 'number' && saved.version > version ? key : null;
    };
  }
  const cells = body.cells as { rowId?: unknown; data?: unknown }[] | undefined;
  if (!Array.isArray(cells) || cells.length !== 1 || typeof cells[0]?.rowId !== 'string' || !cells[0].data || typeof cells[0].data !== 'object' || Object.keys(cells[0].data).length !== 1) return null;
  const rowId = cells[0].rowId, key = `sheet:${sheet![1]}:${rowId}`;
  return response => {
    const saved = response as { rows?: { id?: unknown }[] } | null;
    return Array.isArray(saved?.rows) && saved.rows.some(row => row?.id === rowId) ? key : null;
  };
}

export const PET_WORK_ROUTES = new Set(['grid', 'candidate', 'sheet', 'dashboard', 'blacklist', 'users', 'journal', 'activity', 'import', 'mailing']);
/** Время между проверками ограничено: свёрнутая вкладка и долгий простой не превращаются в награду. */
export function activeWorkElapsed(now: number, lastTick: number, lastInput: number, active: boolean): number {
  if (!active || now < lastTick || now - lastInput >= 60_000) return 0;
  return Math.max(0, Math.min(15_000, now - lastTick, 60_000 - (lastTick - lastInput)));
}
